export const formFields = [
  {
    section: "General Information",
    name: "opcScheduleName",
    label: "Schedule",
    fieldLabel: "OPC Schedule Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [2, 24],
  },
  {
    section: "General Information",
    name: "opcDescription",
    label: "Description",
    fieldLabel: "OPC Description",
    type: "text",
    options: { maxLength: { value: 40, message: "MAXLENGTH_40" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [3, 36],
  },
  {
    section: "General Information",
    name: "opcBasis",
    label: "Basis",
    fieldLabel: "OPC Basis",
    type: "dropdown",
    dropdownCondition: "*Valid Values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [4, 24],
  },
  {
    section: "General Information",
    name: "opcStepCount",
    label: "Steps",
    fieldLabel: "OPC Step Count",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 24],
  },
  {
    section: "General Information",
    name: "opdStepNumber",
    label: "Step Number",
    fieldLabel: "OPD Step Number",
    type: "number",
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 24],
  },
  {
    section: "General Information",
    name: "opdAccumComponentCode",
    label: "Accum Component Code",
    fieldLabel: "OPD Accum Component Code",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 24],
  },
  {
    section: "General Information",
    name: "opdAccumWMadTimestmp",
    label: "After Adj Time",
    fieldLabel: "DSD Accum w/MAD Timestmp?",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 24],
  },
  {
    section: "OOP Max",
    name: "opdMbrOopMaxAmount",
    label: "OOP Max:  Individual",
    fieldLabel: "OPD Mbr OOP Max Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 24],
  },
  {
    section: "OOP Max",
    name: "opdFamilyIndividualAmt",
    label: "OOP Max: Family Individual",
    fieldLabel: "OPD Family Individual Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 55],
  },
  {
    section: "OOP Max",
    name: "opdFamOopMaxAmount",
    label: "OOP Max: Family",
    fieldLabel: "OPD Fam OOP Max Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 24],
  },
  {
    section: "section 3",
    name: "opdPricingTableFlag",
    label: "Copay Pat Pay Table",
    fieldLabel: "OPD Pricing Table Flag",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 24],
  },
  {
    section: "Copay Amount",
    name: "opdBrandCopayAmount",
    label: "Copay Amount: Brand",
    fieldLabel: "OPD Brand Copay Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999.99, message: "MAX_99999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 26],
  },
  {
    section: "Copay Amount",
    name: "opdGenericCopayAmount",
    label: "Copay Amount:  Generic",
    fieldLabel: "OPD Generic Copay Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999.99, message: "MAX_99999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 45],
  },
  {
    section: "Copay Percent",
    name: "opdBrandPercentAmt",
    label: "Copay Percent: Brand",
    fieldLabel: "OPD Brand Percent Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 28],
  },
  {
    section: "Copay Percent",
    name: "opdGenericPercentAmt",
    label: "Copay Percent: Generic",
    fieldLabel: "OPD Generic Percent Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 47],
  },
  {
    section: "section 6",
    name: "opdPercentBasis",
    label: "Percent Basis",
    fieldLabel: "OPD Percent Basis",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 24],
  },
  {
    section: "section 6",
    name: "opdCopayDeductibleFlag",
    label: "Update",
    fieldLabel: "OPD Copay/Deductible Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 24],
  },
  {
    section: "section 6",
    name: "opdCrossOver",
    label: "Cross Over",
    fieldLabel: "OPD Cross Over",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 24],
  },
  {
    section: "section 6",
    name: "planCode",
    label: "Plan Override",
    fieldLabel: "Plan Code",
    type: "lookup",
    externalProgram: { default: "RCPLN018" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "planCode", target: "planCode",legacy:"planCode" },
          { source: "planEffDate", 
            resolver:"formatDateForPresto",
            legacy:"planEffDate",
            target: "planEffDate" },
          { source: "planName", target: "planName",legacy:"planName" },
        ],
      },
      appName: "ACCUMS",
      pageName: "PLAN_CODE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 1],
  },
  {
    section: "section 6",
    name: "planEffDate",
    label: "From Date",
    fieldLabel: "Plan Eff Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 2],
  },
  {
    section: "section 6",
    name: "planName",
    label: "",
    fieldLabel: "Plan Name",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [18, 3],
  },
  {
    section: "section 6",
    name: "opdSendFlag",
    label: "Send",
    fieldLabel: "OPD Send Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 24],
  },
  {
    section: "section 6",
    name: "opdIntPharmAndMedical",
    label: "Integrated Pharmacy and Medical",
    fieldLabel: "OPD Int Pharm and Medical",
    type: "dropdown",
    dropdownCondition: "Deductible + OOP Int List",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 69],
  },
  {
    section: "OOP Max By Family Type (Header)",
    name: "opdOopAmtCardSpouse",
    label: "3  Cardholder & Spouse",
    fieldLabel: "OPD OOP Amt: Card+Spouse",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 36],
  },
  {
    section: "OOP Max By Family Type (Header)",
    name: "opdOopAmtCardDeps",
    label: "4  Cardholder & Dependents",
    fieldLabel: "OPD OOP Amt: Card+Deps",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 36],
  },
  {
    section: "OOP Max By Family Type (Header)",
    name: "opdOopAmtSpouseDeps",
    label: "5  Spouse & Dependents",
    fieldLabel: "OPD OOP Amt: Spouse+Deps",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 36],
  },
  {
    section: "OOP Max By Family Type (Header)",
    name: "opdOopAmtDeps",
    label: "6  Dependents",
    fieldLabel: "OPD OOP Amt: Deps",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 36],
  },
  {
    section: "OOP Max By Family Type (Header)",
    name: "opdOopAmtSpouseOnly",
    label: "7  Spouse Only",
    fieldLabel: "OPD OOP Amt: Spouse Only",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 36],
  },
  {
    section: "OOP Max By Family Type (Header)",
    name: "opdOopAmtMbr1",
    label: "8  Member + 1",
    fieldLabel: "OPD OOP Amt: Mbr+1",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 36],
  },
  {
    section: "OOP Max By Family Type (Header)",
    name: "opdOopAmtCard1",
    label: "9  Cardholder + 1 Dependent",
    fieldLabel: "OPD OOP Amt: Card+1",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 36],
  },
  {
    section: "OOP Max By Family Type (Header)",
    name: "opdOopAmtCard2",
    label: "A  Cardholder + 2 Dependents",
    fieldLabel: "OPD OOP Amt: Card+2",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
      fractionDigits: 2,
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 36],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [22, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [22, 40],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [22, 57],
  },
  {
    section: "Audit Fields",
    name: "oopSubstepExistenceSts",
    label: "Substep Exists",
    fieldLabel: "OOP Substep Existence Sts",
    type: "text",
    options: {},
    fieldNature: "Add: Non-Display , Change: Read-only, View: Read-only",
    position: [22, 69],
  },
];
